import { createRouteRef, createSubRouteRef } from '@mainstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'wb-marketplace',
});

export const searchHomepageRef = createSubRouteRef({
  id: 'wb-marketplace-search',
  parent: rootRouteRef,
  path: '/home',
});
export const dataProductRouteRef = createSubRouteRef({
  id: 'wb-marketplace:dataproduct',
  parent: rootRouteRef,
  path: '/search/:id/*',
});

export const dataProductLegacyRouteRef = createSubRouteRef({
  id: 'wb-marketplace:dataproduct',
  parent: rootRouteRef,
  path: '/products-catalog/:id/*',
});

export const outputPortRouteRef = createSubRouteRef({
  id: 'wb-marketplace:outputPort',
  parent: rootRouteRef,
  path: '/consumable-interface/:id/*',
});

export const dataContractsOverviewRouteRef = createSubRouteRef({
  id: 'wb-marketplace-data-contracts-overview',
  parent: rootRouteRef,
  path: '/data-contracts',
});

export const marketplaceSearchRef = createSubRouteRef({
  id: 'wb-marketplace-search',
  parent: rootRouteRef,
  path: '/search',
});

// route for the business concept map page
export const businessConceptMapRef = createSubRouteRef({
  id: 'wb-marketplace-business-concept-map',
  parent: rootRouteRef,
  path: '/business-concepts-map',
});
